<div class="workflow-container">
  <ng-container *ngIf="filterSelectOptions$ | async as filterSelectOptions; else loading">
    <div *ngIf="showClose" class="action-buttons">
      <button mat-icon-button (click)="removeFilter()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div
      *ngIf="filterSelectOptions.length > 0 && displayInternalFilters !== null"
      [matTooltipDisabled]="canChangeTaskDefinition"
      [matTooltip]="'AUTOMATIONS.EDITOR.FILTERS.ONLY_ONE_CONDITION' | translate"
    >
      <glxy-form-field>
        <glxy-label>{{ 'AUTOMATIONS.EDITOR.FILTERS.FILTER_BY' | translate }}</glxy-label>
        <mat-select [formControl]="filterOptionControl" [required]="true">
          <mat-option
            *ngFor="let option of filterSelectOptions"
            [value]="option.value"
            [disabled]="option.disabled"
            [glxyTooltip]="option.description"
          >
            {{ option.label }}
          </mat-option>
        </mat-select>
      </glxy-form-field>
      <ng-container *ngIf="!!filterOptionControl.value && filterOptionControl.value.inputParameters?.length > 0">
        <automata-output-parameter-selector
          [taskDefinitionId]="filterOptionControl.value.taskDefinitionId"
          [workflowStepOutputParameterContainers]="predecessorOutputParams"
          [defaultDataType]="filterOptionControl.value.dataType"
          [supportedDataTypes]="filterOptionControl.value.dataType ? [filterOptionControl.value.dataType] : []"
          (valueSelected)="outputParamSelected($event)"
          [dataValueThatReferencesAPreviousStep]="filterDataValue"
          [disabled]="!canChangeTaskDefinition"
        ></automata-output-parameter-selector>
      </ng-container>
      <ng-container *ngIf="filterSubgroupOptions$ | async as filterSubgroupOptions">
        <div *ngIf="filterSubgroupOptions.length > 0">
          <glxy-form-field>
            <glxy-label>
              {{ 'AUTOMATIONS.EDITOR.FILTERS.WORKFLOW_STEP_OPTIONS' | translate }}
            </glxy-label>
            <mat-select [formControl]="filterSubgroupControl" [required]="true" [disabled]="!canChangeTaskDefinition">
              <ng-container *ngFor="let option of filterSubgroupOptions">
                <mat-option [value]="option.value">
                  {{ option.label }}
                </mat-option>
              </ng-container>
            </mat-select>
            <glxy-hint>
              {{ 'AUTOMATIONS.EDITOR.FILTERS.WORKFLOW_STEP_HINT' | translate }}
            </glxy-hint>
          </glxy-form-field>
        </div>
      </ng-container>
    </div>
  </ng-container>
  <ng-container *ngFor="let filter of filterValues; let last = last; let index = index">
    <!--  This is where the lookup need to be to change between account group filters and w/e other filters -->
    <div class="edit-mode">
      <ng-container *ngIf="filterValues.length > 1">
        <div class="action-buttons">
          <button mat-icon-button (click)="remove($event, index)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </ng-container>
      <automata-filter-data
        *ngIf="predecessorOutputParams"
        [initialRule]="filter"
        [taskDefinitionId]="currentTaskDefinitionId"
        [predecessorOutputParams]="predecessorOutputParams"
        [currentlySelectedSubgroupId$]="currentlySelectedSubgroup$"
      ></automata-filter-data>
    </div>
    <ng-container *ngIf="!last">
      <div class="operator-selector">
        <mat-button-toggle-group [(value)]="operator">
          <mat-button-toggle [value]="AND">
            {{ 'AUTOMATIONS.EDITOR.FILTERS.COMPARISON.AND' | translate }}
          </mat-button-toggle>
          <mat-button-toggle [value]="OR">
            {{ 'AUTOMATIONS.EDITOR.FILTERS.COMPARISON.OR' | translate }}
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </ng-container>
  </ng-container>
  @if (currentTaskDefinitionId === ifElseBranchWorkflowStepTaskDefinitionId) {
    @if (isGoal) {
      <mat-hint>
        {{ 'AUTOMATIONS.EDITOR.FILTERS.WORKFLOW_STEP_GOAL_DISCLAIMER' | translate }}
      </mat-hint>
    } @else {
      <mat-hint>
        {{ 'AUTOMATIONS.EDITOR.FILTERS.WORKFLOW_STEP_DISCLAIMER' | translate }}
      </mat-hint>
    }
  }
  <a (click)="addMore()" class="more">
    {{ 'AUTOMATIONS.EDITOR.FILTERS.ADD_ANOTHER_CONDITION' | translate }}
  </a>
</div>

<ng-template #loading>
  <div class="side-drawer-shimmer-container">
    <span class="control-container selector stencil-shimmer"></span>
  </div>
</ng-template>
